import React, { Component } from "react";
import PersonnelList from "./personnel-list.js";
import { getPersonnel, getAllPersonnel, addPersonnel, editPersonnel, addOrganization, setPersonnelLockoutStatus } from "../../../../modules/user.js";
import OrganizationCard from "./organization-card.js";
//import OrganizationForm from "./organization-form.js";

import "./manage-personnel.css";

class ManagePersonnel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gettingPersonnel: false,
            addingPersonnel: false,
            personnel: [],
            errors: [],
            organizationFormErrors: [],
            selected_organizations: [],
            shouldHideForm: false,
            addingOrganization: false,
            show_organization_form: false
        };
    }

    componentDidMount() {
        this.getAllPersonnel();
    }

    async getAllPersonnel() {
        let { token } = this.props;
        let { gettingPersonnel } = this.state;

        if (gettingPersonnel) {
            return;
        }

        this.setState({ gettingPersonnel: true });

        let personnelResponse = await getAllPersonnel(token);

        if (personnelResponse.data && personnelResponse.data.success) {
            let personnelData = personnelResponse.data.personnel;
            this.setState({ gettingPersonnel: false, personnel: personnelData });
        }
        else {
            if (personnelResponse.data) {
                alert(personnelResponse.data.message);
            }
            else {
                alert("Something went wrong...");
            }

            this.setState({ gettingPersonnel: false });
        }
    }

    toggleCurrentOrganization(organization) {
        let { selected_organizations } = this.state;
        let newSelectedOrganizations = [];
        let found = false;
        for (let i = 0; i < selected_organizations.length; i++) {
            let currentOrganization = selected_organizations[i];

            if (currentOrganization.id === organization.id) {
                found = true;
            }
            else {
                newSelectedOrganizations.push(currentOrganization);
            }
        }

        if (!found) {
            newSelectedOrganizations.push(organization);
        }

        this.setState({ selected_organizations: newSelectedOrganizations });
    }

    removeArchivedPersonnel(personnelID) {
        let { personnel } = this.state;
        let newPersonnelList = [];

        for (let index in personnel) {
            let currentPersonnel = personnel[index];
            if (currentPersonnel.id !== personnelID) {
                newPersonnelList.push(currentPersonnel);
            }
        }
        this.setState({ personnel: newPersonnelList });
    }

    addNewlyAddedPersonnelTolist(newPersonnelInfo) {
        let { personnel } = this.state;
        let newPersonnelList = [...personnel, newPersonnelInfo];
        this.setState({ personnel: newPersonnelList });
    }

    updatePersonnelLockoutStatusDone(personnelID, newLockoutStatus) {
        let { personnel } = this.state;
        let newPersonnel = [];

        for (let index in personnel) {
            let currentPersonnel = personnel[index];

            if (currentPersonnel.id === personnelID) {
                currentPersonnel.lockout = newLockoutStatus;
                newPersonnel.push(currentPersonnel);
            }
            else {
                newPersonnel.push(currentPersonnel);
            }
        }

        this.setState({ personnel: newPersonnel });
    }

    updateEditedPersonnel(editedPersonnelData) {
        let { personnel } = this.state;
        let newPersonnel = [];

        for (let index in personnel) {
            let currentPersonnel = personnel[index];

            if (currentPersonnel.id === editedPersonnelData.id) {
                newPersonnel.push(editedPersonnelData);
            }
            else {
                newPersonnel.push(currentPersonnel);
            }
        }

        this.setState({ personnel: newPersonnel });
    }

    personnelFormHidden() {
        this.setState({ shouldHideForm: false, errors: [] });
    }

    async editPersonnel(personnelID, editData) {
        let { token } = this.props;
        let { addingPersonnel } = this.state;

        if (addingPersonnel) {
            return;
        }

        this.setState({ addingPersonnel: true, errors: [] });

        let esitPersonnelResponse = await editPersonnel(token, personnelID, editData);

        if (esitPersonnelResponse && esitPersonnelResponse.data) {
            let data = esitPersonnelResponse.data;

            if (data.success) {
                //Add new personnel to the list

                this.updateEditedPersonnel(data.edited_personnel_data);

                this.setState({
                    shouldHideForm: true
                })
            }
            else {
                let errorMessage = data.message;
                this.setState({ errors: [errorMessage] });
            }
        }
        else {
            //Something went wrong while adding personnel.
        }
        this.setState({ addingPersonnel: false });
    }

    showOrganizationForm() {
        this.setState({ show_organization_form: true });
    }

    closeOrganizationForm() {
        this.setState({ show_organization_form: false });
    }

    async setLockoutStatus(personnelID, newStatus) {
        let { token } = this.props;

        let setResponse = await setPersonnelLockoutStatus(token, personnelID, newStatus);

        if (setResponse.data.success) {
            this.updatePersonnelLockoutStatusDone(personnelID, newStatus);
        }
    }

    async addOrganization(organizationName) {
        let { token, add_new_organization_func } = this.props;
        let { addingOrganization } = this.state;

        if (addingOrganization) {
            return;
        }

        this.setState({ addingOrganization: true });

        let addOrganizationResult = await addOrganization(token, organizationName);

        if (addOrganizationResult && addOrganizationResult.data) {
            let data = addOrganizationResult.data;

            if (data.success) {
                add_new_organization_func(data.new_organization);
                this.setState({ show_organization_form: false });
            }
            else {
                let errorMessage = data.message;
                this.setState({ organizationFormErrors: [errorMessage] });
            }
        }
        this.setState({ addingOrganization: false });
    }

    async addPersonnel(newPersonnelData) {
        let { token } = this.props;
        let { addingPersonnel } = this.state;

        if (addingPersonnel) {
            return;
        }

        this.setState({ addingPersonnel: true, errors: [] });

        let addPersonnelResponse = await addPersonnel(token, newPersonnelData);

        if (addPersonnelResponse && addPersonnelResponse.data) {
            let data = addPersonnelResponse.data;

            if (data.success) {
                //Add new personnel to the list

                this.addNewlyAddedPersonnelTolist(data.new_personnel);

                this.setState({
                    shouldHideForm: true
                })
            }
            else {
                let errorMessage = data.message;
                this.setState({ errors: [errorMessage] });
            }
        }
        else {
            //Something went wrong while adding personnel.
        }
        this.setState({ addingPersonnel: false });
    }

    async getPersonnel(organization) {
        let { token } = this.props;
        let { gettingPersonnel } = this.state;

        if (gettingPersonnel) {
            return;
        }

        this.setState({ gettingPersonnel: true, current_organization: organization });

        let personnelResponse = await getPersonnel(token, organization.id);

        if (personnelResponse.data && personnelResponse.data.success) {
            let personnelData = personnelResponse.data.personnel;
            this.setState({ gettingPersonnel: false, personnel: personnelData });
        }
        else {
            if (personnelResponse.data) {
                alert(personnelResponse.data.message);
            }
            else {
                alert("Something went wrong...");
            }
            this.setState({ gettingPersonnel: false });
        }
    }

    printOrgs() {
        let { organizations } = this.props;
        let { selected_organizations } = this.state;

        return organizations.map((organization) => {
            let isCurrent = false;
            for (let i = 0; i < selected_organizations.length; i++) {
                let currentOrganization = selected_organizations[i];

                if (currentOrganization.id === organization.id) {
                    isCurrent = true;
                    break;
                }
            }
            return <OrganizationCard key={organization.id} organization={organization} is_current={isCurrent} on_click={this.toggleCurrentOrganization.bind(this)} />
        });
    }

    render() {
        let { organizations, roles, token/*, user*/ } = this.props;
        let { personnel, selected_organizations, errors, shouldHideForm/*, show_organization_form, organizationFormErrors*/ } = this.state;
        //let isBusinessGroupAdmin = user.role === "Business Group Admin" ? true : false;
        return (
            <div>
                <div className='manage_personnel_organizations_section'>
                    <div className='manage_personnel_organizations_section_title'>
                        <span>Your Facilities: </span>
                        {/* {isBusinessGroupAdmin && <span className='manage_personnel_add_organization' onClick={this.showOrganizationForm.bind(this)}>Add Facility</span>} */}
                    </div>
                    {/* {isBusinessGroupAdmin && <OrganizationForm show={show_organization_form} on_close={this.closeOrganizationForm.bind(this)} on_submit={this.addOrganization.bind(this)} errors={organizationFormErrors} />} */}
                    {this.printOrgs()}
                </div>
                {<PersonnelList archive_done={this.removeArchivedPersonnel.bind(this)} personnel_data={personnel} add_personnel={this.addPersonnel.bind(this)} edit_personnel={this.editPersonnel.bind(this)} selected_organizations={selected_organizations} roles={roles} organizations={organizations} errors={errors} should_hide_form={shouldHideForm} personnel_form_hidden={this.personnelFormHidden.bind(this)} token={token} set_personnel_lockout={this.setLockoutStatus.bind(this)} />}
            </div>
        );
    }
}

export default ManagePersonnel;



// WEBPACK FOOTER //
// ./src/components/containers/manager-dashboard/manage-personnel/manage-personnel.js